// /explore — the ad-free aggregate page. Stacks every secondary
// content module with a stable anchor id, so SectionTiles can deep-
// link readers from the post-10pm compositions to whichever module
// they want without dragging the inline module back onto the live
// homepage.
//
// Hard rule: no partner / ad strips on this page. That means no
// SpuntStripBanner, no VotmtBanner, no LiveDebatePlayer, no
// ManifestoPromptStrip (the strip lives lower in the manifesto
// section directly as a teaser; the partner stuff stays off).
//
// Each section reuses the existing homepage component verbatim, with
// its existing FeatureSection flag wrapper preserved — editor toggles
// in /admin/flags still hide modules here exactly as they do on the
// homepage.

import Header from '../Header';
import Footer from '../Footer';
import FeatureSection from '../FeatureSection';
import SurveyTracker from '../SurveyTracker';
import QuizModule from '../Quiz/QuizModule';
import MapModule from '../DistrictMap/MapModule';
import CandidatesModule from '../Candidates/CandidatesModule';
import ProposalsModule from '../Proposals/ProposalsModule';
import ManifestoPromptStrip from '../Manifesto/ManifestoPromptStrip';
import './ExplorePage.css';

export default function ExplorePage() {
  return (
    <>
      <Header />
      <main className="explore-page">
        <div className="explore-page__hero">
          <p className="explore-page__kicker">Lovin Malta · Election 2026</p>
          <h1 className="explore-page__title">Explore</h1>
          <p className="explore-page__lede">
            Every section of the dashboard in one place — the polls
            tracker, the quiz, the candidates, the proposals, the
            district map, and the AI manifesto explorer. Skip to any
            section from the menu of tiles on the homepage.
          </p>
        </div>

        <section id="surveys" className="explore-page__section">
          <FeatureSection sectionKey="survey_tracker" label="Survey tracker">
            <SurveyTracker />
          </FeatureSection>
        </section>

        <section id="quiz" className="explore-page__section">
          <FeatureSection sectionKey="quiz" label="Quiz">
            <QuizModule />
          </FeatureSection>
        </section>

        <section id="map" className="explore-page__section">
          <FeatureSection sectionKey="district_map" label="District map">
            <MapModule />
          </FeatureSection>
        </section>

        <section id="candidates" className="explore-page__section">
          <FeatureSection sectionKey="candidates" label="Candidates">
            <CandidatesModule />
          </FeatureSection>
        </section>

        <section id="proposals" className="explore-page__section">
          {/* ProposalsModule self-renders its own header; it's not
              wrapped in a FeatureSection on the homepage either. */}
          <ProposalsModule />
        </section>

        <section id="manifestos" className="explore-page__section">
          {/* Funnel to /ai_manifesto. Same component the homepage
              uses — types-a-question → navigates to the explorer. */}
          <ManifestoPromptStrip />
        </section>

        <p className="explore-page__back">
          <a href="/">← Back to the homepage</a>
        </p>
      </main>
      <Footer />
    </>
  );
}
